module.exports = __webpack_public_path__ + "static/Impact-3-508da16c1ed54bcaad264dbc2f81057b.jpg";